import { TimeCategory } from '@interfaces/base';

export const TILE_COLORS = {
	[TimeCategory.IDEAL]: 'Time/Light/Ideal',
	[TimeCategory.PAID]: 'Time/Light/Paid',
	[TimeCategory.SCHEDULED]: 'Time/Light/Scheduled',
	[TimeCategory.ACTUAL]: 'Time/Light/Actual',
} as const;

export const TILE_HEIGHT = 90;

export const ACTIVE_TIME_COEF_IN_CASE_CYCLE_TIME_ZERO = 0.8;

export const SWAP_ANIMATION_DURATION = 450;
export const REMEASURING_AFTER_ANIMATION_TIMING = SWAP_ANIMATION_DURATION + 50;

export const TIME_TILE_EDIT_ACTION_CONFIG = {
	iconSize: 14,
	buttonSize: 24,
}